'use strict'

import React, { useRef } from 'react';

import {
	useFloating,
	offset,
	shift,
	flip,
	arrow,
	size,
	autoPlacement,
	hide,
	inline,
} from '@floating-ui/react-dom';

const stockMiddlewares = {
	offset,
	shift,
	flip,
	arrow,
	size,
	autoPlacement,
	hide,
	inline,
};

export default ({
	init,
	show,
	children,
	content,
	className,
	style: userStyle,
	arrowClassName,
	arrowStyle: userArrowStyle,
}) => {

	const arrowRef = useRef(null);

	const middleware = init.middleware({ ...stockMiddlewares, arrowRef });

	const _init = { ...init, middleware };

	const {
		x,
		y,
		reference,
		floating,
		strategy,
		middlewareData: {
			arrow: {
				x: arrowX,
				y: arrowY,
			} = {}
		},
	} = useFloating(_init);

	const defaultStyle = {
		position: strategy,
		top: y ?? 0,
		left: x ?? 0,
	};

	const defaultArrowStyle = {
		position: strategy,
		top: arrowY ?? 0,
		left: arrowX ?? 0,
	};

	const style = { ...defaultStyle, ...userStyle };
	const arrowStyle = { ...defaultArrowStyle, ...userArrowStyle };

	return (
		<>
			<div ref={ reference }>
				{ children }
			</div>
			{ show &&
				<div
					ref={ floating }
					style={ style }
					className={ className }
				>
					<div
						ref={ arrowRef }
						className={ arrowClassName }
						style={ arrowStyle }
					/>
					<div>
						{ content }
					</div>
				</div>
			}
		</>
	);
};
